const passiveAction = gains => ({
  enabled: () => true,
  execute: context => {
    const { party } = context;
    const { resources, traits } = party;

    for (const key in gains.resources || {}) {
      resources.delta({ [key]: gains.resources[key] }, context);
    }
    for (const key in gains.traits || {}) {
      traits.delta({ [key]: gains.traits[key] }, context);
    }
    return gains;
  },
  effects: () => gains
});

export default passiveAction;
